import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import ProductCoChart from '../../../../components/productCoChart';
// styles
import {
  ColStyled,
  ColStyledCtaContainer,
  RowStyled,
} from './styles';

const config = {
  productComparisonChart: {
    columns: [
      {
        Header: 'Benefits',
        headerCellClassName: 'column-benefits',
        accessor: 'feature',
      },
      {
        Header: 'Fixed Annuity',
        accessor: 'fixedAnnuity',
      },
      {
        Header: 'Variable Annuity',
        accessor: 'variableAnnuity',
      },
    ],
    data: [
      {
        feature: (
          <>
            Option to convert to an income plan at retirement to receive income payments for life
          </>
        ),
        variableAnnuity: 'true',
        fixedAnnuity: 'true',
      },
      {
        feature: <>A guaranteed death benefit following the death of the owner of the annuity&#42;</>,
        variableAnnuity: 'true',
        fixedAnnuity: 'true',
      },
      {
        feature: <>Tax&#45;deferred growth</>,
        variableAnnuity: 'true',
        fixedAnnuity: 'true',
      },
      {
        feature: <>Multiple investment sub&#45;account options that are managed by dedicated and experienced professionals&#42;&#42;</>,
        variableAnnuity: 'true',
        fixedAnnuity: '',
      },
      {
        feature: <>Variable investments that can provide the potential to keep pace with inflation&#42;&#42;&#42;</>,
        variableAnnuity: 'true',
        fixedAnnuity: '',
      },
      {
        feature: <>Tax&#45;free, cost&#45;free transfers of assets between available investment sub&#45;accounts&#42;&#42;&#42;&#42;</>,
        variableAnnuity: 'true',
        fixedAnnuity: '',
      },
    ],
    hideSectionHeading: false,
    instructionalText: 'To compare insurance products, select any two below.',
    sectionHeading: <>Meet your goals with the right type of annuity.</>,
  },
};

export default () => (
  <SectionContainer
    id='fixed-variable-annuities-product-comparison-chart'
    backgroundVariant='lightC'
    themeType='lightTheme'
    className='nmx-nested nmx-product-comparison-table'
    moduleName='product-comparison-chart-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col align='center'>
        <ProductCoChart
          id='fixed-variable-annuities-product-comparison-chart'
          data-app-name='fixed-variable-annuities-product-comparison-chart'
          data-static-config={config} />
        <RowStyled align='center'>
          <ColStyledCtaContainer>
            <Link
              variant='buttonLinkPrimary'
              themeType='lightTheme'
              id='fixed-variable-annuities-product-comparison-chart-cta-fafa'
              linkUrl='/find-a-financial-advisor/'>
              Connect with an advisor
            </Link>
          </ColStyledCtaContainer>
          <ColStyled>
            <Typography
              component='small'
              align='left'
              nextElement='typography'>
              &#42;Variable Annuities are sold by prospectus only. Clients should carefully consider the investment objectives, risks, expenses and charges of the investment company before they invest. A Northwestern Mutual Investment Services Registered Representative can provide clients with a contract and sub&#45;account prospectus that will contain the information noted above and other important information that clients should read carefully before they invest or send money.
            </Typography>
            <Typography
              component='small'
              align='left'
              nextElement='typography'>
              &#42;&#42;The performance of variable sub&#45;accounts is not guaranteed, and variable annuities are subject to market risk, including loss of principal. No investment strategy can guarantee a profit or protect against a loss.
            </Typography>
            <Typography
              component='small'
              align='left'
              nextElement='typography'>
              &#42;&#42;&#42;Variable annuities are subject to fees and charges, such as mortality and expense charges, annual contract fees, sales charges, and portfolio expense fees associated with the underlying investment options.
            </Typography>
            <Typography
              component='small'
              align='left'
              disableBottomPadding>
              &#42;&#42;&#42;&#42;Please refer to the Prospectus for details of all fees and charges.
            </Typography>
          </ColStyled>
        </RowStyled>
      </Col>
    </Row>
  </SectionContainer>
);
